import SortButton from "@/components/SortButton";
import { Column, Header } from "@tanstack/react-table";
import { useDataTableOptions } from "../hooks/useDataTableOptions";

interface SortColumnButtonProps<TData> {
  header: Header<TData, unknown>;
  className?: string;
}

export default function SortColumnButton<TData>({
  header,
  className,
}: SortColumnButtonProps<TData>) {
  const options = useDataTableOptions();
  if (!header.column.getCanSort()) {
    return null;
  }

  const sort = options.getSortValue(header.column.id);
  const sortedOrFiltered = options.isFilteredOrSorted(header.column.id);

  const onSortChange = (
    column: Column<TData, unknown>,
    direction: "asc" | "desc" | false,
  ) => {
    if (direction === false) {
      options.clearSorting(column.id);
    } else {
      options.setSorting(column.id, direction);
    }
  };

  return (
    <SortButton
      header={header}
      className={className}
      sortValue={sort}
      forceSortedStyle={sortedOrFiltered}
      onSortChange={onSortChange}
    />
  );
}
